import Loadable from 'react-loadable';
import React from 'react';

let OYOChatWidget = function () {
    return <div/>
}

let Loading = function () {
    return <div/>
}

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
    OYOChatWidget = Loadable({
        loader: () => import("../../../ui-components/OYOChat"),
        loading: Loading
    });
}

export default OYOChatWidget;
